import { connect } from 'react-redux';
import { StoreState } from '../../../../redux/reducers/store.types';
import { Dispatch } from '../../../../redux/redux.types';
import { locateFile } from '../../../file-manager/redux/file-manager.actions';
import { getJobBasedOperation } from '../common/compress/job-based-group.selectors';
import { closeOperationGroup } from '../operation-groups.actions';
import {
  CompressGroup,
  DispatchProps,
  OwnProps,
  StateProps,
} from './compress-group';

const mapStateToProps = (state: StoreState, ownProps: OwnProps) => ({
  operation: getJobBasedOperation(state, ownProps.groupId),
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    closeGroup: (groupId: string) => dispatch(closeOperationGroup(groupId, [])),
    locateFile: (fileId: string) => {
      dispatch(locateFile(fileId));
    },
  };
};

export const CompressGroupContainer = connect<
  StateProps,
  DispatchProps,
  OwnProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(CompressGroup);
